import { getCategoryContent } from '@backmarket/http-api/src/api-specs-model-comparison'
import { useHttpFetch } from '@backmarket/nuxt-module-http/useHttpFetch'

import { useCurrentCategory } from './useCurrentCategory'

export function useFetchCategory() {
  return useHttpFetch(getCategoryContent, {
    pathParams: {
      category: useCurrentCategory(),
    },
  })
}
